// The office's one breadcrumb (UI/UX audit, 27 Oct 2026, item 8).
//
// A detail page sits under a register: Goods in › PO line, Spec master › version. One
// component says so the same way on every one, so no page carries its own "back" link
// that half does the job: a landmark (`<nav aria-label="Breadcrumb">`), an ordered
// list, a real link for every parent, and `aria-current="page"` on the last item so a
// screen reader hears where it is, not only a list of places it could go.
import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  /** Where the crumb goes. The last crumb is the page itself and carries none. */
  to?: string;
}

export function Breadcrumb({ items }: { items: Crumb[] }) {
  if (items.length === 0) return null;
  const last = items.length - 1;
  return (
    <nav aria-label="Breadcrumb" className="text-(length:--fs-sm)">
      <ol className="m-0 flex list-none flex-wrap items-center gap-(--s1) p-0">
        {items.map((item, i) => (
          <li key={`${i}-${item.label}`} className="flex items-center gap-(--s1)">
            {i > 0 ? (
              <span aria-hidden="true" className="text-(--muted-2)">
                ›
              </span>
            ) : null}
            {i < last && item.to ? (
              <Link to={item.to} className="underline decoration-(--border-strong) underline-offset-[3px] hover:decoration-current">
                {item.label}
              </Link>
            ) : (
              <span aria-current={i === last ? 'page' : undefined} className={i === last ? 'text-(--muted)' : undefined}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default Breadcrumb;
